import * as types from "./actionTypes";

export const fetchEmployeeResignation = (unit_id) => ({
  type: types.FETCH_EMPLOYEE_RESIGNATION,
  payload:{unit_id},
});

export const saveEmployeeResignation = (payload) => ({
  type: types.SAVE_EMPLOYEE_RESIGNATION,
  payload,
});

export const saveEmployeeRejoin = (payload) => ({
  type: types.SAVE_EMPLOYEE_REJOIN,
  payload,
});
